/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 扫描使用的协议，可以是 'tcp' 或 'udp'。
 */
export const Protocol = {
  Tcp: "tcp",
  Udp: "udp",
} as const;
/**
 * 扫描使用的协议，可以是 'tcp' 或 'udp'。
 */
export type Protocol = ClosedEnum<typeof Protocol>;

export const Protocol$zodSchema = z.enum([
  "tcp",
  "udp",
]).describe("扫描使用的协议，可以是 'tcp' 或 'udp'。");

export type GetNetworkPortscanRequest = {
  host: string;
  port: number;
  protocol?: Protocol | undefined;
};

export const GetNetworkPortscanRequest$zodSchema: z.ZodType<
  GetNetworkPortscanRequest
> = z.object({
  host: z.string().describe("需要扫描的目标主机，可以是域名或IP地址。"),
  port: z.int().describe("需要扫描的端口号，范围是 1 到 65535。"),
  protocol: Protocol$zodSchema.default("tcp"),
});

export type GetNetworkPortscanInternalServerErrorDetails = {};

export const GetNetworkPortscanInternalServerErrorDetails$zodSchema: z.ZodType<
  GetNetworkPortscanInternalServerErrorDetails
> = z.object({});

/**
 * 扫描失败。服务器在执行扫描时发生内部错误。
 */
export type GetNetworkPortscanInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetNetworkPortscanInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkPortscanInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetNetworkPortscanInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() =>
      GetNetworkPortscanInternalServerErrorDetails$zodSchema
    ).optional(),
    message: z.string().optional(),
  }).describe("扫描失败。服务器在执行扫描时发生内部错误。");

export type GetNetworkPortscanBadRequestDetails = {};

export const GetNetworkPortscanBadRequestDetails$zodSchema: z.ZodType<
  GetNetworkPortscanBadRequestDetails
> = z.object({});

/**
 * 请求参数无效。请检查 `host`, `port` 等参数是否提供且格式正确。
 */
export type GetNetworkPortscanBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetNetworkPortscanBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkPortscanBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkPortscanBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkPortscanBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("请求参数无效。请检查 `host`, `port` 等参数是否提供且格式正确。");

/**
 * 扫描完成！返回端口的状态。
 */
export type GetNetworkPortscanResponseBody = {
  ip?: string | undefined;
  port?: number | undefined;
  port_status?: string | undefined;
  protocol?: string | undefined;
};

export const GetNetworkPortscanResponseBody$zodSchema: z.ZodType<
  GetNetworkPortscanResponseBody
> = z.object({
  ip: z.string().optional(),
  port: z.int().optional(),
  port_status: z.string().optional(),
  protocol: z.string().optional(),
}).describe("扫描完成！返回端口的状态。");

export type GetNetworkPortscanResponse =
  | GetNetworkPortscanResponseBody
  | GetNetworkPortscanBadRequestResponseBody
  | GetNetworkPortscanInternalServerErrorResponseBody;

export const GetNetworkPortscanResponse$zodSchema: z.ZodType<
  GetNetworkPortscanResponse
> = z.union([
  z.lazy(() => GetNetworkPortscanResponseBody$zodSchema),
  z.lazy(() => GetNetworkPortscanBadRequestResponseBody$zodSchema),
  z.lazy(() => GetNetworkPortscanInternalServerErrorResponseBody$zodSchema),
]);
